import AccountsSettings from './accountSettingsPage.view';

export default AccountsSettings;
